/*
  Furniture kit builder (snippets/kx-cabinet-kit.liquid): each module of a kit is its own
  product; the shopper keeps the ones they want and the buy box's own button adds exactly
  those. The kit parent itself is display-only and is never added.

  The <select>s are the state. Where the browser can, each is dressed as the site's own
  drop-down (.kxdd - the control approved for the toilet sets, see kx-product-kit.liquid /
  kx-kit-calc.js): thumbnail, name, price, "Детайли" link, bottom sheet on a phone. Choosing
  an option writes the <select> and fires its change event, so the rest of this file does not
  know the drop-down exists - and works unchanged if it is not built (old browser, tests).

  "Variant" mode (snippets/kx-variant-picker.liquid, data-variant-nav on the root): the same
  drop-down over a product's own variants; choosing one navigates to it. See init().

  "Base" mode (snippets/kx-pack-addons.liquid, data-base-cents on the root): the product on the
  page IS sold - a promo pack - and the drop-down only adds an optional extra, the flush button.
  The pack's own variant always goes into the cart, the chosen extra with it; the big price follows the choice.
*/
(function () {
  'use strict';
  // This pure calculation also drives the tests: no parent kit variant is accepted.
  function selection(choices, quantity) {
    const q = Number(quantity);
    if (!Number.isSafeInteger(q) || q < 1) throw new Error('Изберете валидно количество.');
    const items = [];
    let unitCents = 0;
    const seen = new Set();
    choices.forEach(function (c) {
      if (!c.id) return;
      if (c.disabled || !/^\d+$/.test(String(c.id)) || !Number.isSafeInteger(c.cents) || c.cents < 0) throw new Error('Избраният модул не е наличен.');
      if (seen.has(String(c.id))) throw new Error('Модулът е избран повече от веднъж.');
      seen.add(String(c.id));
      items.push({ id: Number(c.id), quantity: q });
      unitCents += c.cents;
    });
    return { items: items, unitCents: unitCents, totalCents: unitCents * q, quantity: q };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { selection: selection };
  if (typeof document === 'undefined') return;

  // the shop's own money format ("€{{amount_with_comma_separator}}" -> €275,59), as kx-kit-calc.js
  function money(cents, format) {
    const fixed = (Math.round(cents) / 100).toFixed(2).split('.');
    const whole = fixed[0], frac = fixed[1];
    let value;
    if (/amount_no_decimals_with_comma_separator/.test(format)) value = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    else if (/amount_with_comma_separator/.test(format)) value = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + frac;
    else if (/amount_no_decimals/.test(format)) value = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    else value = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + frac;
    return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, value);
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  // ---- the drop-down ------------------------------------------------------------------
  let openDD = null, backdrop = null;
  const sheetMQ = typeof window !== 'undefined' && window.matchMedia ? window.matchMedia('(max-width:749px)') : { matches: false };
  function optData(o) {
    const d = o.dataset || {};
    return { value: o.value, none: !o.value, name: d.name || (o.textContent || '').trim(), sub: d.sub || '', price: d.price || '',
             img: d.img || '', href: d.url || '', disabled: !!o.disabled, prompt: d.prompt || '', meta: d.meta || '' };
  }
  function thumb(d, ask) {
    if (ask) return '<span class="kxdd__thumb is-add"></span>';
    return '<span class="kxdd__thumb' + (d.none ? ' is-none' : '') + '"' +
      (d.img && !d.none ? ' style="background-image:url(&quot;' + esc(d.img) + '&quot;)"' : '') + '></span>';
  }
  function ddClose(dd, refocus) {
    dd.querySelector('.kxdd__panel').hidden = true;
    dd.classList.remove('is-open', 'is-up');
    dd.querySelector('.kxdd__btn').setAttribute('aria-expanded', 'false');
    if (backdrop) backdrop.hidden = true;
    document.documentElement.classList.remove('kxdd-lock');
    if (openDD === dd) openDD = null;
    if (refocus) dd.querySelector('.kxdd__btn').focus();
  }
  function ddOpen(dd) {
    if (openDD && openDD !== dd) ddClose(openDD, false);
    const panel = dd.querySelector('.kxdd__panel');
    panel.hidden = false;
    dd.classList.add('is-open');
    dd.querySelector('.kxdd__btn').setAttribute('aria-expanded', 'true');
    openDD = dd;
    if (sheetMQ.matches) {
      if (!backdrop) {
        backdrop = document.createElement('div');
        backdrop.className = 'kxdd-backdrop';
        backdrop.addEventListener('click', function () { if (openDD) ddClose(openDD, true); });
        document.body.appendChild(backdrop);
      }
      backdrop.hidden = false;
      document.documentElement.classList.add('kxdd-lock');
    } else {
      dd.classList.remove('is-up');
      panel.style.maxHeight = '';
      // Where the list fits: under the control, else over it - but never under the page header
      // (an "up" list used to slide beneath it and hide its first options). If neither side has
      // room for the whole list it takes the roomier side and scrolls inside.
      const r = panel.getBoundingClientRect();
      const hdr = document.querySelector('.shopify-section-group-header-group');
      const topLimit = hdr ? Math.max(0, hdr.getBoundingClientRect().bottom) : 0;
      const below = window.innerHeight - r.top - 10;
      const above = dd.querySelector('.kxdd__btn').getBoundingClientRect().top - 6 - topLimit - 10;
      if (r.height > below) {
        if (above >= r.height) dd.classList.add('is-up');
        else if (above > below && above >= 240) { dd.classList.add('is-up'); panel.style.maxHeight = Math.floor(above) + 'px'; }
        else if (below >= 240) panel.style.maxHeight = Math.floor(below) + 'px';
        else panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }
    const cur = panel.querySelector('.kxdd__opt[aria-selected="true"]') || panel.querySelector('.kxdd__opt:not(.is-disabled)');
    if (cur) {
      try { cur.focus({ preventScroll: true }); } catch (e) { cur.focus(); }
      // "Без ..." is the last row: when it is the current choice, show the list from its top,
      // not its end - the options are what the shopper opened it for
      if (cur.classList.contains('is-none')) panel.scrollTop = 0; else cur.scrollIntoView({ block: 'nearest' });
    }
  }
  function ddUpdate(sel) {
    const dd = sel._kxdd;
    if (!dd) return;
    const d = optData(sel.selectedOptions[0] || sel.options[0]);
    // An optional extra nobody has picked yet (data-prompt, kx-pack-addons): the closed control
    // invites - "Добави бутон по избор" - instead of stating "Без бутон", which shoppers read
    // as "this pack has no button to offer". The list row keeps its "Без ..." name.
    const ask = d.none && !!d.prompt;
    dd.querySelector('.kxdd__cur').innerHTML = thumb(d, ask) +
      '<span class="kxdd__curtxt"><span class="kxdd__curname">' + esc(ask ? d.prompt : d.name) + '</span>' +
      '<span class="kxdd__curmeta">' + (d.none ? esc(d.meta || 'не е включен в комплекта') : esc(d.price)) + '</span></span>';
    Array.prototype.forEach.call(dd.querySelectorAll('.kxdd__opt'), function (o) {
      o.setAttribute('aria-selected', o.dataset.value === sel.value ? 'true' : 'false');
    });
  }
  function enhance(sel, n) {
    if (sel._kxdd || typeof sel.closest !== 'function' || typeof document.createElement !== 'function') return;
    const row = sel.closest('.kxsel');
    const box = row && row.querySelector('.kxsel__box');
    if (!box) return;
    const label = row.querySelector('.kxsel__label');
    const lid = label && label.id ? label.id : 'kxcab-l-' + n;
    if (label) label.id = lid;
    let h = '<button type="button" class="kxdd__btn" aria-haspopup="listbox" aria-expanded="false"' +
            ' aria-labelledby="' + lid + ' kxcab-v-' + n + '"><span class="kxdd__cur" id="kxcab-v-' + n + '"></span>' +
            '<span class="kxdd__chev" aria-hidden="true"></span></button>' +
            '<div class="kxdd__panel" role="listbox" aria-labelledby="' + lid + '" hidden>' +
            '<div class="kxdd__sheethead"><b>' + esc(label ? label.textContent : '') + '</b>' +
            '<button type="button" class="kxdd__done">Готово</button></div><div class="kxdd__list">';
    Array.prototype.forEach.call(sel.options, function (o) {
      const d = optData(o);
      h += '<div class="kxdd__opt' + (d.none ? ' is-none' : '') + (d.disabled ? ' is-disabled' : '') + '" role="option"' +
           ' tabindex="-1" aria-selected="false" data-value="' + esc(d.value) + '"' + (d.disabled ? ' aria-disabled="true"' : '') + '>' +
           thumb(d) + '<span class="kxdd__name">' + esc(d.name) +
           (d.none ? '<small>ако не ви трябва или вече го имате</small>' : (d.sub ? '<small>' + esc(d.sub) + '</small>' : '')) + '</span>' +
           '<span class="kxdd__side"><span class="kxdd__price">' + (d.disabled ? 'изчерпан' : esc(d.price)) + '</span>' +
           (d.href && !d.none ? '<a class="kxdd__more" href="' + esc(d.href) + '" target="_blank" rel="noopener" tabindex="-1">Детайли ↗</a>' : '') +
           '</span><span class="kxdd__check" aria-hidden="true"></span></div>';
    });
    h += '</div></div>';
    const dd = document.createElement('div');
    dd.className = 'kxdd';
    dd.innerHTML = h;
    box.parentNode.insertBefore(dd, box.nextSibling);
    row.classList.add('kxsel--dd');
    sel._kxdd = dd;
    function choose(o) {
      if (o.classList.contains('is-disabled')) return;
      sel.value = o.dataset.value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      ddClose(dd, true);
    }
    const btn = dd.querySelector('.kxdd__btn');
    btn.addEventListener('click', function () { dd.classList.contains('is-open') ? ddClose(dd, true) : ddOpen(dd); });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); ddOpen(dd); }
    });
    dd.querySelector('.kxdd__done').addEventListener('click', function () { ddClose(dd, true); });
    dd.querySelector('.kxdd__list').addEventListener('click', function (e) {
      if (e.target.closest('a')) return;                 // "Детайли" opens the module's own page
      const o = e.target.closest('.kxdd__opt');
      if (o) choose(o);
    });
    dd.querySelector('.kxdd__panel').addEventListener('keydown', function (e) {
      const list = Array.prototype.slice.call(dd.querySelectorAll('.kxdd__opt:not(.is-disabled)'));
      const i = list.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (list[i + 1] || list[0]).focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); (list[i - 1] || list[list.length - 1]).focus(); }
      else if (e.key === 'Home') { e.preventDefault(); list[0].focus(); }
      else if (e.key === 'End') { e.preventDefault(); list[list.length - 1].focus(); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (i > -1) choose(list[i]); }
      else if (e.key === 'Escape') { e.preventDefault(); ddClose(dd, true); }
      else if (e.key === 'Tab') { ddClose(dd, false); }
    });
  }
  document.addEventListener('click', function (e) {
    if (openDD && !openDD.contains(e.target) && !(backdrop && e.target === backdrop)) ddClose(openDD, false);
  });
  if (typeof window !== 'undefined' && window.addEventListener) window.addEventListener('resize', function () { if (openDD) ddClose(openDD, false); });

  // ---- the kit ------------------------------------------------------------------------
  function init(root) {
    if (root.dataset.cabinetReady) return;
    // "Variant" mode (snippets/kx-variant-picker.liquid): the rows are the product's own variants
    // - a Geberit pack with one flush plate or another. Nothing is added or summed here; picking
    // a row opens that variant, the way the text pills it replaces did.
    if ('variantNav' in root.dataset) {
      root.dataset.cabinetReady = 'true';
      Array.from(root.querySelectorAll('[data-cabinet-choice]')).forEach(function (select, i) {
        enhance(select, (root.dataset.formId || 'variant') + '-' + i);
        ddUpdate(select);
        select.addEventListener('change', function () {
          const o = select.selectedOptions[0];
          if (o && o.dataset.nav) location.assign(o.dataset.nav);
        });
      });
      return;
    }
    const form = document.getElementById(root.dataset.formId);
    if (!form) return;
    root.dataset.cabinetReady = 'true';
    const choices = Array.from(root.querySelectorAll('[data-cabinet-choice]'));
    const button = form.querySelector('[name="add"]');
    const price = root.closest('.kxpr-buy').querySelector('.kxpr-price');
    const quantity = form.querySelector('[name="quantity"]');
    const summary = root.querySelector('[data-cabinet-summary]');
    const error = root.querySelector('[data-cabinet-error]');
    const fmt = root.dataset.money || '€{{amount_with_comma_separator}}';
    // base mode: the page's own product is part of every order
    const base = root.dataset.baseCents ? { cents: Number(root.dataset.baseCents) } : null;
    let busy = false;
    // The manufacturer's photo of the cabinet with the chosen basin on it (data-kit-img, per
    // option and for the finish on view; "Без мивка" = the bare cabinet). Only on a choice the
    // shopper makes - the page itself opens on the right photo. A choice with no photo of its
    // own leaves the picture as it is.
    function showKitImage(select) {
      const o = select.selectedOptions && select.selectedOptions[0];
      const url = o && o.dataset && o.dataset.kitImg;
      if (!url || typeof document.querySelector !== 'function') return;
      const main = document.querySelector('.kxpr-gal [id^="KxprMain-"]');
      if (!main) return;
      main.src = url;
      main.removeAttribute('srcset');
      const file = function (u) { return String(u || '').split('?')[0].split('/').pop(); };
      Array.prototype.forEach.call(document.querySelectorAll('.kxpr-thumb'), function (t) {
        t.classList.toggle('is-active', file(t.dataset.full) === file(url));
      });
    }
    function state() {
      const s = selection(choices.map(function (select) {
        const option = select.selectedOptions[0];
        return { id: option ? option.value : '', cents: option ? Number(option.dataset.cents) : 0, disabled: option ? option.disabled : true };
      }), quantity ? quantity.value : 1);
      if (base) {
        const own = form.querySelector('[name="id"]');
        s.extras = s.items.length;
        s.items.unshift({ id: Number(own.value), quantity: s.quantity });
        s.unitCents += base.cents;
        s.totalCents = s.unitCents * s.quantity;
      }
      return s;
    }
    function render() {
      choices.forEach(function (select) {
        const option = select.selectedOptions[0];
        const row = (typeof select.closest === 'function' && select.closest('.kxsel')) || select.parentElement;
        const link = row.querySelector('[data-cabinet-link]');
        if (link) { link.hidden = !option || !option.value; if (option && option.dataset.url) link.href = option.dataset.url; }
        ddUpdate(select);
      });
      try {
        const s = state();
        price.textContent = money(s.unitCents, fmt);
        if (base) {
          const picked = choices.map(function (select) { return select.selectedOptions[0]; }).filter(function (o) { return o && o.value; });
          if (picked.length) {
            // "Комплект" for a promo pack; a vanity cabinet names itself (data-base-label="Шкаф")
            summary.innerHTML = esc(root.dataset.baseLabel || 'Комплект') + ' + ' + picked.map(function (o) { return esc(o.dataset.name || ''); }).join(' + ') +
              ' · общо <b>' + money(s.totalCents, fmt) + '</b>' + (s.quantity > 1 ? ' за ' + s.quantity + ' бр.' : '');
            summary.hidden = false;
          } else {
            summary.textContent = '';
            summary.hidden = true;
          }
          // preselected add-on (a vanity cabinet opens as cabinet + basin, kx-set-price.liquid):
          // the caption under the big price says what it holds and keeps the cabinet's own price
          if (root.dataset.setLabel) {
            const sub = document.querySelector('[data-kxkit-mainsub]');
            if (sub) sub.textContent = picked.length
              ? 'Комплект: ' + root.dataset.setLabel + ' · ' + (root.dataset.baseAlone || 'продуктът') + ' самостоятелно ' + money(base.cents, fmt)
              : (root.dataset.noneSub || '');
          }
        } else if (s.items.length) {
          const n = s.items.length;
          summary.innerHTML = 'Избрани: <b>' + n + (n === 1 ? ' модул' : ' модула') + '</b> · общо <b>' + money(s.totalCents, fmt) + '</b>' +
            (s.quantity > 1 ? ' за ' + s.quantity + ' бр.' : '');
        } else {
          summary.textContent = 'Изберете поне един модул.';
        }
        button.disabled = busy || !s.items.length;
      } catch (e) { summary.textContent = e.message; summary.hidden = false; button.disabled = true; }
    }
    choices.forEach(function (select, i) {
      enhance(select, (root.dataset.formId || 'kit') + '-' + i);
      select.addEventListener('change', function () { error.hidden = true; render(); showKitImage(select); });
    });
    if (quantity) { quantity.addEventListener('input', render); quantity.addEventListener('change', render); }
    // Capture on the form intercepts before the theme's ProductForm bubble handler.
    form.addEventListener('submit', async function (event) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (busy) return;
      let s;
      try { s = state(); if (!s.items.length) { render(); return; } }
      catch (e) { error.textContent = e.message; error.hidden = false; return; }
      busy = true; error.hidden = true; render();
      button.classList.add('loading'); button.setAttribute('aria-busy', 'true');
      const spinner = button.querySelector('.loading__spinner'); if (spinner) spinner.classList.remove('hidden');
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const body = { items: s.items };
      if (cart && cart.getSectionsToRender) { body.sections = cart.getSectionsToRender().map(x => x.id); body.sections_url = location.pathname; }
      if (cart && cart.setActiveElement) cart.setActiveElement(document.activeElement);
      const base = (window.routes && window.routes.cart_add_url) || ((window.Shopify && Shopify.routes.root) || '/') + 'cart/add';
      try {
        const response = await fetch(base.replace(/\.js$/, '') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || 'Неуспешно добавяне. Опитайте отново.');
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cabinet-kit', cartData: data });
        if (cart && cart.renderContents) { cart.classList.remove('is-empty'); cart.renderContents(data); }
        else location.assign((window.routes && window.routes.cart_url) || '/cart');
      } catch (e) { error.textContent = e.message || 'Неуспешно добавяне. Опитайте отново.'; error.hidden = false; }
      finally { busy = false; button.classList.remove('loading'); button.removeAttribute('aria-busy'); if (spinner) spinner.classList.add('hidden'); render(); }
    }, true);
    render();
    // Deep link from a basin's own page ("Шкаф към мивката", snippets/kx-basin-cabinets.liquid):
    // ?basin=<product id> opens the cabinet with THAT basin in the drop-down instead of the
    // cheapest one, so the shopper lands on the pair they came from.
    try {
      const want = typeof location !== 'undefined' && location.search ? new URLSearchParams(location.search).get('basin') : null;
      if (want) choices.forEach(function (select) {
        const o = Array.prototype.filter.call(select.options, function (x) { return x.dataset && x.dataset.pid === want && !x.disabled; })[0];
        if (o && !o.selected) { select.value = o.value; select.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    } catch (e) { /* an unreadable address must not break the buy box */ }
  }
  function boot() { document.querySelectorAll('[data-cabinet-kit]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
